import { useState, useEffect } from 'react';
import labelsData from '../data/labels.json';

/**
 * Хук для загрузки геоданных карты в зависимости от уровня навигации
 *
 * @param {string} level - 'russia' | 'federal-district' | 'subject'
 * @param {string|null} currentRegion - ID текущего региона
 * @returns {object} { geoData, labels, loading, error, districtMapping }
 */
function useMapData(level, currentRegion) {
  const [geoData, setGeoData] = useState(null);
  const [districtMapping, setDistrictMapping] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadGeoData = async () => {
      setLoading(true);
      setError(null);

      try {
        let data = null;
        let mapping = null;

        if (level === 'russia') {
          // Загрузка карты России со всеми субъектами
          const [topoResponse, districtResponse] = await Promise.all([
            fetch('/data/russia.json'),
            fetch('/data/federal-districts.json')
          ]);

          if (topoResponse.ok && districtResponse.ok) {
            data = await topoResponse.json();
            mapping = await districtResponse.json();
          }

        } else if (level === 'federal-district') {
          const [topoResponse, districtResponse] = await Promise.all([
            fetch('/data/russia.json'),
            fetch('/data/federal-districts.json')
          ]);

          if (topoResponse.ok && districtResponse.ok) {
            data = await topoResponse.json();
            mapping = await districtResponse.json();
          }

        } else if (level === 'subject') {
          const response = await fetch('/data/russia.json');

          if (response.ok) {
            data = await response.json();
          }
        }

        if (isMounted) {
          setGeoData(data);
          setDistrictMapping(mapping);
          setLoading(false);
        }
      } catch (err) {
        // При ошибке загрузки просто используем placeholder (не показываем ошибку)
        if (isMounted) {
          setGeoData(null);
          setDistrictMapping(null);
          setLoading(false);
        }
      }
    };

    loadGeoData();

    return () => {
      isMounted = false;
    };
  }, [level, currentRegion]);

  return {
    geoData,
    districtMapping,
    labels: labelsData,
    loading,
    error
  };
}

export default useMapData;